import LeadflowWindow from '../LeadflowWindow';

if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-undef
    LeadflowWindow.REACT_APP_LEADFLOW_API = process.env.REACT_APP_LEADFLOW_API;
}
export function getServiceUrl(): string {
    return LeadflowWindow.REACT_APP_LEADFLOW_API;
}
